<form [formGroup]="form">
  <ng-content></ng-content>

  <label class="im:checkbox-label">
    <input
      class="im:checkbox-input"
      type="checkbox"
      formControlName="notifyWhenReceivingMessage"
    />
    <span class="im:body">{{
      'messenger.setting_notify_me_l' | translate
    }}</span>
  </label>
</form>
